import { SafeArea } from '@capacitor-community/safe-area';
import { useEffect } from 'react';

export function useSafeAreaTopPadding() {
  useEffect(() => {
    SafeArea.getSafeAreaInsets().then(({ insets }) => {
      if (insets && typeof insets.top === 'number') {
        document.body.style.setProperty('--safe-area-top', `${insets.top}px`);
      }
    });
  }, []);
}
